import { Component } from 'react'
import withRouter from '../components/withRouter'
import QRCode from 'qrcode.react'
import { API } from 'aws-amplify'
import Logo from '../images/GigLoca_Logo_Light.png'
import { FaUser, FaCloudDownloadAlt } from 'react-icons/fa'
import { MdOutlineContactPhone, MdOutlineEmail, MdOutlineTitle } from 'react-icons/md'
import { IoIosPhonePortrait } from 'react-icons/io'
//import { LuCopyCheck, LuCopy} from 'react-icons/lu'
//import vCardsJs from 'vcards-js'
import VCard from 'vcard-creator'
import './node.css'

class Contact extends Component {
    constructor(props) {
        super(props)

        this.state = {
            card: null,
            copy: false
        }
    }

    componentDidMount() {
        this.props.setMode('fan')
        const { path } = this.props
        const id = path.id || null

        const headers = { Authorization: `Basic VSQzcm5hbWU6UGEkc3dvcmQ=` }
        API.get('lt', `card/${id}`, { headers })
            .then(resp => {
                this.setState({ card: resp.data && resp.data.contact ? resp.data.contact : null })
            })
            .catch(err => {
                const { navigate } = this.props
                navigate(`/`)
            })
    }

    /* handleCopy(email) {
        this.setState({ copy: true })
        navigator.clipboard.writeText(email)
    }
 */

    handleDownload(card) {
        const vCard = new VCard()
        vCard.addName(card.lastName, card.firstName)
        vCard.addCompany('Gigloca')
        if(card.title) vCard.addJobtitle(card.title)
        vCard.addPhoneNumber(card.phone, 'PREF;WORK')
        vCard.addURL('https://gigloca.com')
        vCard.addEmail(card.email)

        const vcfString = vCard.toString()

        const blob = new Blob([vcfString], { type: 'text/vcf;charset=utf-8' })
        const url = URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.download = 'giglocaContact.vcf'
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        URL.revokeObjectURL(url)
    }

    getSplash() {
        return <div className='My-Splash'>
            <img src={Logo} className='Node-Logo' alt="GigLoca" />
        </div>
    }
    getCard() {
        if (this.state.card) {
            return <div>
                <div className='Node-Row Node-Flex-Wrap'><MdOutlineContactPhone /></div>
                <div className='Node-Row Node-Flex'>{this.state.card.img ? <img className='TopMenu-User' src={`https://localtalent-upload.s3.amazonaws.com/public/${this.state.card.img}`} alt='Contact' /> : <FaUser />}<div style={{ fontSize: '18pt', fontWeight: 'bold', color: '#fff', marginLeft: '10px', paddingTop: '5px' }}>{this.state.card.name || 'Unlisted'}</div></div>
                <div className='Node-Row Node-Flex'><div className='TopMenu-User'><MdOutlineEmail /></div><div style={{ fontSize: '18pt', fontWeight: 'bold', color: '#fff', marginLeft: '10px', paddingTop: '5px', cursor: 'pointer' }}>{<a href={`mailto:${this.state.card.email}`}>{this.state.card.email}</a> || 'No Email'}</div></div>
                <div className='Node-Row Node-Flex'><div className='TopMenu-User'><IoIosPhonePortrait /></div><div style={{ fontSize: '18pt', fontWeight: 'bold', color: '#fff', marginLeft: '10px', paddingTop: '5px' }}>{this.state.card.phone || 'No Phone'}</div></div>
                {this.state.card.title && <div className='Node-Row Node-Flex'><div className='TopMenu-User'><MdOutlineTitle /></div><div style={{ fontSize: '18pt', fontWeight: 'bold', color: '#fff', marginLeft: '10px', paddingTop: '5px' }}>{this.state.card.title || 'Representative'}</div></div>}
                <div style={{ fontSize: '18pt', fontWeight: 'bold', color: '#fff' }} className='Node-Row Node-Flex-Wrap'><a href="https://gigloca.com/contactus">Contact Gigloca</a></div>
                <div style={{ fontSize: '18pt', fontWeight: 'bold', color: '#fff' }} className='Node-Row Node-Flex-Wrap'><a href="https://gigloca.com/about.html">About Gigloca</a></div>
                <div style={{ marginTop: '10px', fontSize: '36px', color: '#fff' }} className='Node-Row Node-Flex-Wrap'><div style={{ cursor: 'pointer' }} onClick={() => this.handleDownload(this.state.card)}><FaCloudDownloadAlt /></div></div>
                <div style={{ marginTop: '10px' }} className='Node-Row Node-Flex-Wrap'><QRCode value={`https://gigloca.com/contact/${this.state.card.card}`} /></div>
            </div>
        }
    }

    render() {
        return <div style={{ paddingTop: '10vh', overflowY: 'auto' }} className={`Empty-Container Node-Black`}>
            <div className="Node-Row Node-Flex-Wrap"><img src={Logo} className='Calendar-Logo' alt="GigLoca" /></div>
            {
                this.state.splash ? this.getSplash() : this.getCard()
            }
        </div>
    }
}

export default withRouter(Contact)